









import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import moment from "moment";
import Chart from "@/shared/components/charts/Chart.vue";
import PocGLineChart from "@/shared/components/charts/PocGLineChart.vue";
import { GradientPoint, InvestmentCustodian } from "@/shared/types";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useThemeStore } from "@/shared/store/theme";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    Chart,
    PocGLineChart
  }
})
export default class InvestmentLineChart extends Vue {

  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  featureFlagStore = useFeatureFlagStore();
  themeStore = useThemeStore();

  @Prop({ default: 220 })
  height: number;

  @Prop({ default: 6 })
  initialDisplayMonths: number;

  @Prop({ default: InvestmentCustodian.None })
  investmentCustodian: InvestmentCustodian;

  @Prop()
  displayMonthNames: boolean;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  get balancesLineChart () {
    return {
      classes: "balances-chart",
      width: 1064,
      height: this.height,
      hasHovers: false
    };
  }

  positiveDataSetFillGradient: GradientPoint[] = [
    {
      alpha: 0.0,
      color: "#ffffff"
    },
    {
      alpha: 0.0,
      color: "#ffffff"
    } ];

  get selectedStartDate () {
    return moment().subtract((this.initialDisplayMonths), "months");
  }

  get isLoaded () {
    return this.investmentDailyBalanceStore.investmentDataIsLoaded && (
        // Don't show HSAB graph until we start collecting daily balances from them
        this.investmentCustodian !== InvestmentCustodian.HsaBank || this.investmentDailyBalanceStore.hasDailyBalances);
  }

  selectedEndDate = moment();

  mounted () {
    this.investmentDailyBalanceStore.setCurrentEndDateKey(this.selectedEndDate.format("YYYYMMDD"));
    this.loadChartData();
  }

  loadChartData () {
    this.investmentDailyBalanceStore.loadDailyInvestmentBalances(this.loadDailyInvestmentBalancesArgs);
  }

  get loadDailyInvestmentBalancesArgs () {
    return {
      startDate: this.selectedStartDate.format("YYYY-MM-DD"),
      endDate: this.selectedEndDate.format("YYYY-MM-DD"),
      username: this.username,
      partnerId: this.partnerId,
      investmentCustodian: this.investmentCustodian};
  }

  @Watch("loadDailyInvestmentBalancesArgs")
  reloadDailyBalancesChart () {
    this.loadChartData();
  }
}
